import React from 'react';
import { useSelector } from 'react-redux';
import TaxBillDetail from '../../components/taxbillmng/TaxBillDetail';

const TaxBillDetailContainer = () => {
  const { taxbill, roInfo } = useSelector(
    ({ taxbillModule }) => ({
      taxbill: taxbillModule.taxbill.taxbill,
      roInfo: taxbillModule.taxbill.roInfo,
    }),
  );

  return <TaxBillDetail taxbill={taxbill} roInfo={roInfo}/>
};

export default TaxBillDetailContainer;
